const create = require('./create')

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} [out] - mat4 receiving operation result
 * @param {vec3} vec - offset (vector) of translation
 * @returns {mat4} a new matrix
 * @alias module:modeling/maths/mat4.fromTranslation
 * @example
 * let matrix = fromTranslation([1, 2, 3])
 */
const fromTranslation = (...params) => {
  let out
  let v
  if (params.length === 1) {
    out = create()
    v = params[0]
  } else {
    out = params[0]
    v = params[1]
  }
  out[0] = 1
  out[1] = 0
  out[2] = 0
  out[3] = 0
  out[4] = 0
  out[5] = 1
  out[6] = 0
  out[7] = 0
  out[8] = 0
  out[9] = 0
  out[10] = 1
  out[11] = 0
  out[12] = v[0]
  out[13] = v[1]
  out[14] = v[2]
  out[15] = 1
  return out
}

module.exports = fromTranslation
